window.addEventListener('resize', renormalize, false);
document.addEventListener("DOMContentLoaded", normalize);

function normalize() {    
    var grids = document.querySelectorAll(".row.normalize-height");
    //console.log(grids);
    
    [].forEach.call(grids, function (row) {
        var pseudoRows = [];
        var pseudoRowHeights = [];

        var i = -1;
        var items = row.querySelectorAll(".normalize-item");
        [].forEach.call(items, function (item) {
            var pos = item.offsetLeft - row.offsetLeft;
            if (pos < 50) {
                i++;
                pseudoRows.push({ key: i, cols: [] });
                pseudoRowHeights.push(0);
            }
            pseudoRows[i].cols.push(item);
            if (item.clientHeight > pseudoRowHeights[i]) {
                pseudoRowHeights[i] = item.clientHeight;
            }
        });

        for (var i = 0; i < pseudoRows.length; i++) {
            var psuedoHeight = pseudoRowHeights[i];
            [].forEach.call(pseudoRows[i].cols, function (item) {
                item.style.height = psuedoHeight + "px";
            });
        }  
    });    
}
function renormalize() {
    clearnormalize();
    normalize();
}
function clearnormalize() {
    var items = document.querySelectorAll(".normalize-item");
    [].forEach.call(items, function (item) {
        item.removeAttribute("style");
    });
}


// WEBPACK FOOTER //
// ./Components/Shared/normalizeheight.js